module.exports = __webpack_public_path__ + "static/media/eyk-borderless.e67ac5f2.webp";